import { render } from "./vstatement.vue?vue&type=template&id=2dd3d4b4&scoped=true"
import script from "./vstatement.vue?vue&type=script&lang=js"
export * from "./vstatement.vue?vue&type=script&lang=js"

import "./vstatement.vue?vue&type=style&index=0&id=2dd3d4b4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd3d4b4"]])

export default __exports__